import * as React from 'react';

import { useNavigate } from 'js/lib/useRouter';

import { Button, CardSection, CardV2 } from '@coursera/coursera-ui';

import { toProgramSkillSet } from 'bundles/program-common/links';

import _t from 'i18n!nls/program-home';

import 'css!./__styles__/SkillSetCompletionBanner';

type Props = {
  skillSetName: string;
  programSlug: string;
  objectiveSlug: string;
};

const SkillSetCompletionBannerFC = ({ skillSetName, programSlug, objectiveSlug }: Props): JSX.Element | null => {
  const navigate = useNavigate();
  const onViewSkillObjectiveClick = (href: string) => (e: React.MouseEvent) => {
    e?.preventDefault();
    if (objectiveSlug) {
      navigate(href);
    }
  };

  if (!skillSetName || !programSlug || !objectiveSlug) {
    return null;
  }

  const href = toProgramSkillSet(programSlug, objectiveSlug);
  return (
    <CardV2 rootClassName="rc-SkillSetCompletionBanner" showBorder={true}>
      <CardSection rootClassName="card-section">
        <div className="main-container">
          <div className="text-container">
            <p className="title">{_t("You've completed the #{skillSetName} SkillSet!", { skillSetName })}</p>
            <p className="description">
              {_t('Keep making progress in this SkillSet or explore other SkillSets to reach your career goals.')}
            </p>
          </div>
          <Button
            type="secondary"
            size="sm"
            label={_t('Explore SkillSets')}
            onClick={onViewSkillObjectiveClick(href)}
            tag="a"
            htmlAttributes={{ href }}
          />
        </div>
      </CardSection>
    </CardV2>
  );
};

export default SkillSetCompletionBannerFC;
